import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';

/**
 * Modal de confirmación para eliminar una tarjeta guardada.
 */
const DeleteCardModal = ({
  card = null,
  onConfirm = () => {},
  onClose = () => {},
  loading = false,
}) => {
  const literals = useLiterals('mercadopago');
  const deleteModalLiterals = literals.deleteCardModal || {};

  if (!card) {
    return null;
  }

  const cardDisplayName = card.payment_method?.name || 'Tarjeta';
  const lastFourDigits = card.last_four_digits || '';

  return (
    <Modal
      title={deleteModalLiterals.title || 'Eliminar tarjeta'}
      onClose={onClose}
    >
      <div className='text-center p-4'>
        <div className='mb-6'>
          {card.payment_method?.thumbnail && (
            <img
              src={card.payment_method.thumbnail}
              alt={cardDisplayName}
              className='mb-4'
              style={{ width: '60px', height: 'auto' }}
            />
          )}
          <p className='mb-2'>{deleteModalLiterals.description || '¿Estás seguro de que deseas eliminar esta tarjeta?'}</p>
          <p className='text-neutral-500 mb-0'>
            <strong>{cardDisplayName}</strong>
            {' •••• '}
            {lastFourDigits}
          </p>
          {card.cardholder?.name && (
            <p className='text-neutral-500 small mt-2'>{card.cardholder.name}</p>
          )}
        </div>
        <div className='flex gap-2 justify-between'>
          <Button
            onClick={onClose}
            type='secondary'
            text={deleteModalLiterals.cancelButton || literals.common?.cancel || 'Cancelar'}
            disabled={loading}
          />
          <Button
            onClick={onConfirm}
            type='primary'
            text={deleteModalLiterals.confirmButton || 'Eliminar'}
            loading={loading}
            disabled={loading}
            style={{ backgroundColor: 'var(--color-danger)', borderColor: 'var(--color-danger)' }}
          />
        </div>
      </div>
    </Modal>
  );
};

DeleteCardModal.propTypes = {
  card: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default DeleteCardModal;
